class HotspotComponent extends HTMLElement {
  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    const dots = this.querySelectorAll('.hotspot-dot');
    const products = this.querySelectorAll('.custom-product-hotspot');

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        dots.forEach(d => d.classList.remove('active'));
        products.forEach(p => p.classList.add('hotspothidden'));

        dot.classList.add('active');

        const product = this.querySelector(`#hotspot-product-${index + 1}`);
        if (product) {
          product.classList.remove('hotspothidden');
        }
      });
    });
  }
}

customElements.define('hotspot-component', HotspotComponent);
